<template>
    <div v-if="activities.length" class="activity-card">
        <button
            type="button"
            class="activity-toggle"
            :aria-expanded="expanded"
            @click="expanded = !expanded"
        >
            <span>{{ title }}</span>
            <i
                :class="expanded ? 'fi fi-chevron-up' : 'fi fi-chevron-down'"
            ></i>
        </button>
        <div v-if="expanded" class="activity-list">
            <div
                v-for="activity in activities"
                :key="activity.id"
                class="activity-item"
            >
                <span
                    class="activity-status"
                    :class="{
                        active: activity.status === 'active',
                        failed: activity.status === 'failed',
                    }"
                    aria-hidden="true"
                >
                    <i
                        :class="
                            activity.status === 'complete'
                                ? 'fi fi-check'
                                : activity.status === 'failed'
                                ? 'fi fi-alert-circle'
                                : 'fi fi-loader'
                        "
                    ></i>
                </span>
                <strong>{{ activity.label }}</strong>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PattyActivityTimeline',
    props: {
        activities: { type: Array, default: () => [] },
        complete: { type: Boolean, default: false },
    },
    data() {
        return { expanded: !this.complete };
    },
    computed: {
        title() {
            return this.complete ? 'What Patty checked' : 'Patty is checking';
        },
    },
    watch: {
        complete(isComplete) {
            this.expanded = !isComplete;
        },
    },
};
</script>

<style scoped>
.activity-card {
    border: 1px solid var(--neutral-500);
    border-radius: var(--radius-default);
    background: var(--white);
    overflow: hidden;
}
.activity-toggle {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--space-3);
    border: 0;
    background: transparent;
    color: var(--neutral-900);
    font-weight: 700;
}
.activity-list {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
    padding: 0 var(--space-3) var(--space-3);
}
.activity-item {
    display: grid;
    grid-template-columns: 1.5rem minmax(0, 1fr);
    gap: var(--space-2);
    align-items: start;
    font-size: 0.875rem;
}
.activity-status {
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    display: grid;
    place-items: center;
    color: var(--success);
}
.activity-status.active {
    color: var(--primary-500);
    background: var(--primary-50);
}
.activity-status.failed {
    color: var(--danger);
}
.activity-status.active i {
    animation: activity-spin 1s linear infinite;
}
@keyframes activity-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
